import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { fetchDeviceTree } from '@blade-sxp/monitor/api/device-management/control';
import { isEmpty } from 'lodash';
import { HandleDeviceIdTree } from '@blade/common/store/deviceTree';
let DeviceCascader = class DeviceCascader extends Vue {
    multiple;
    clearable;
    disabled;
    collapseTags;
    customedDisabledFunc;
    value;
    excludeDeviceId;
    options = [];
    get deviceIdList() {
        let data = [];
        if (this.multiple) {
            data = this.value;
        }
        else {
            if (!isEmpty(this.value) && Array.isArray(this.value)) {
                data = this.value?.[0];
            }
            else {
                data = this.value;
            }
        }
        return data;
    }
    set deviceIdList(val) {
        if (this.multiple) {
            this.$emit('input', val);
        }
        else {
            if (!isEmpty(val)) {
                this.$emit('input', [val]);
            }
            else {
                this.$emit('input', []);
            }
        }
    }
    onChangeDeviceId(val, oldVal) {
        if (!isEmpty(val) && val.length > 100) {
            this.$nextTick(() => {
                this.deviceIdList = oldVal;
                this.$message({
                    customClass: 'more-message',
                    showClose: true,
                    message: `${this.$t('moreTip')}`,
                    iconClass: 'war-icon',
                });
            });
        }
        if (!isEmpty(val) && val.length === 100) {
            this.disabledTree();
        }
        if (!isEmpty(val) && val.length < 100) {
            this.allTree();
        }
    }
    created() {
        this.getTree();
    }
    allTree() {
        const deep = (treeData) => {
            return treeData.map((item) => {
                if (!isEmpty(item.children)) {
                    deep(item.children);
                }
                item.disabled = false;
                return {
                    ...item,
                };
            });
        };
        return deep(this.options);
    }
    disabledTree() {
        const deep = (treeData) => {
            return treeData.map((item) => {
                if (this.deviceIdList.includes(item.id) && item.nodeType !== 'DEVICE_GROUP') {
                    item.disabled = false;
                    return {
                        ...item,
                    };
                }
                else if (!this.deviceIdList.includes(item.id) && item.nodeType !== 'DEVICE_GROUP') {
                    item.disabled = true;
                    return {
                        ...item,
                    };
                }
                if (!isEmpty(item.children)) {
                    deep(item.children);
                }
            });
        };
        return deep(this.options);
    }
    async getTree() {
        try {
            let data = [];
            const { trees } = (await fetchDeviceTree());
            data = trees;
            this.options = this.mapTree(data) || [];
            HandleDeviceIdTree.getDeviceIdList(data);
            if (!isEmpty(data)) {
                this.$emit('data-finish', true);
            }
        }
        catch (error) {
            throw error;
        }
    }
    mapTree(originTree) {
        if (!isEmpty(originTree)) {
            let treeData = [];
            originTree.forEach((node, i) => {
                const { id, children, name, nodeType } = node;
                const isGroup = nodeType === 'DEVICE_GROUP';
                if (!(isGroup && isEmpty(children))) {
                    const mapped = {
                        ...node,
                        id: id + (isGroup ? 'DEVICE_GROUP' : ''),
                        value: id + (isGroup ? 'DEVICE_GROUP' : ''),
                        label: name,
                        children: this.mapTree(children),
                        disabled: (isEmpty(children) && isGroup) || (this.customedDisabledFunc && this.customedDisabledFunc(node)),
                    };
                    if (id === this.excludeDeviceId) {
                    }
                    else {
                        mapped.disabled = mapped.disabled || this.allChildrenDisabled(mapped);
                        treeData.push(mapped);
                    }
                }
            });
            return treeData;
        }
    }
    allChildrenDisabled(node) {
        const { children } = node;
        if (node.nodeType !== 'DEVICE_GROUP') {
            return false;
        }
        for (const item of children) {
            if (!item.disabled) {
                return false;
            }
        }
        return true;
    }
    remove(val) {
        this.$emit('remove-value', val);
    }
    changeValue(val) {
        this.$emit('change', val);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "multiple", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "clearable", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "collapseTags", void 0);
__decorate([
    Prop()
], DeviceCascader.prototype, "customedDisabledFunc", void 0);
__decorate([
    Prop()
], DeviceCascader.prototype, "value", void 0);
__decorate([
    Prop()
], DeviceCascader.prototype, "excludeDeviceId", void 0);
__decorate([
    Watch('deviceIdList', { deep: true })
], DeviceCascader.prototype, "onChangeDeviceId", null);
DeviceCascader = __decorate([
    Component({
        name: 'DeviceCascader',
        components: {},
        i18n: {
            messages: {
                en: {
                    placeholderTip: 'you can select at least one camera for now',
                    moreTip: 'A maximum of 100 devices can be selected simultaneously.',
                },
                zh: {
                    placeholderTip: '请至少选择一个摄像头',
                    moreTip: '最多可同时选择100台设备。',
                },
            },
        },
    })
], DeviceCascader);
export default DeviceCascader;
